angular.module('umCore').constant('submissionConstant', {
    event: {
        REDIRECT_TO_OVERVIEW: 'Submission.RedirectToOverview',
        CLOSE_CHECKLIST: 'Wizard.CloseChecklist',
        TOGGLE_CHECKLIST: 'Wizard.ToggleChecklist',
        CHECKLIST_DID_OPEN: 'Wizard.ChecklistDidOpen',
        CHECKLIST_DID_CLOSE: 'Wizard.ChecklistDidClose',
        CLOSE_COLLABORATION: 'Wizard.CloseCollaboration',
        TOGGLE_COLLABORATION: 'Wizard.ToggleCollaboration',
        COLLABORATION_DID_OPEN: 'Wizard.CollaborationDidOpen',
        COLLABORATION_DID_CLOSE: 'Wizard.CollaborationDidClose',
        COLLABORATION_FILTER_CHANGE: 'Wizard.CollaborationFilterChange',
        RELOAD_SUBMISSION: 'Submission.ReloadSubmission',
        REFRESH_SUBMISSION: 'PersistentConnection.RefreshSubmission',
        REFRESH_BREADCRUMBS: 'Submission.RefreshBreadcrumbs',
        REFRESH_ACTIONS_BUTTONS: 'Submission.RefreshActionsButtons',
        CONTEXT_CHANGED: 'Submission.ContextChanged',
        REFRESH_CHECKLIST: 'Submission.RefreshChecklist',
        REFRESH_CHECKLIST_ITEM_COUNT: 'Submission.RefreshChecklistItemCount',
        OPEN_OWNER_URI: 'Submission.OpenOwnerUri',
        SELECT_DEFAULT_NAVIGATION_ITEM: 'Submission.SelectDefaultNavigationItem',
        CLOSE_NAVIGATION: 'Submission.CloseNavigation',
        CURRENT_SUBMISSION_CHANGE: 'Submission.CurrentSubmissionChange',
        OPEN_SUBMISSION_LIST_CHANGE: 'Submission.OpenSubmissionListChange',
        CLOSE_SUBMISSION_MODULE: 'Submission.CloseSubmissionModule',
        CLOSE_ACTIVITY_STREAM: 'Wizard.CloseActivityStream',
        TOGGLE_ACTIVITY_STREAM: 'Wizard.ToggleActivityStream',
        TOGGLE_SNIPPETS: 'Wizard.ToggleSnippets',
        TOGGLE_NAVIGATION_MENU: 'Navigation.ToggleNavigationMenu',
        CLOSE_SNIPPETS: 'Wizard.CloseSnippets',
        ACTIVITY_STREAM_DID_OPEN: 'Wizard.ActivityStreamDidOpen',
        ACTIVITY_STREAM_DID_CLOSE: 'Wizard.ActivityStreamDidClose',
        SNIPPETS_DID_OPEN: 'Wizard.SnippetsDidOpen',
        SNIPPETS_DID_CLOSE: 'Wizard.SnippetsDidClose',
        CLEAR_VISIBLE_TOOLTIP: 'Submission.ClearVisibleTooltip',
        CREATE_COLLABORATION_ITEM_MESSAGE: 'Submission.CreateCollaborationItemMessage',
        UPDATE_COLLABORATION_ITEM_MESSAGE: 'Submission.UpdateCollaborationItemMessage',
        DELETE_COLLABORATION_ITEM_MESSAGE: 'Submission.DeleteCollaborationItemMessage',
        CREATE_CHAT_MESSAGE: 'Submission.CreateChatMessage',
        UPDATE_CHAT_MESSAGE: 'Submission.UpdateChatMessage',
        DELETE_CHAT_MESSAGE: 'Submission.DeleteChatMessage',
        SET_CURRENT_SNIPPET_FIELD: 'Submission.SetCurrentSnippetField',
        REFRESH_SNIPPETS_TOGGLER: 'Submission.RefreshSnippetsToggler',
        UPDATE_ACCOUNT_GRID: 'Submission.UpdateAccountGrid',
        PREQUALIFICATION_START_LOADING: 'Submission.Prequalification.StartLoading',
        PREQUALIFICATION_STOP_LOADING: 'Submission.Prequalification.StopLoading',
        PREQUALIFICATION_CHANGE_FORM_ID: 'Submission.Prequalification.ChangeFormId',
        HISTORY_FILTER_CHANGE: 'Submission.HistoryFilterChange',
        OPEN_PROPOSAL_QUOTES_DRAWER: 'Submission.OpenProposalQuotesDrawer',
        CLOSE_PROPOSAL_QUOTES_DRAWER: 'Submission.CloseProposalQuotesDrawer',
        OPEN_CHAT_COLLABORATION: 'Submission.OpenChatCollaboration',
        ATTACHMENT_EDITOR_DID_OPEN: 'Wizard.AttachmentEditorDidOpen'
    },
    originator: {
        UMS_MANUAL: 0,
        UMS_AUTO: 1,
        UPLOAD: 2,
        REWRITE: 3,
        UPLOAD_ACORD_PDF: 4,
        EXCHANGE: 5,
        EMAIL_RECEIVER: 6,
        COPY: 7,
        SPLIT: 8
    },
    breadcrumbsStatus: {
        COMPLETE: 'COMPLETE',
        IN_PROGRESS: 'IN_PROGRESS',
        NOT_COMPLETE: 'NOT_COMPLETE'
    },
    CONTEXT_QUOTE: 'Submission.ContextQuote',
    CONTEXT_SUBMISSION: 'Submission.ContextSubmission',
    CONTEXT_REPORT: 'Submission.ContextReport',
    CONTEXT_POLICY_ISSUANCE: 'Submission.ContextPolicyIssuance',
    CONTEXT_POLICY: 'Submission.ContextPolicy',
    CONTEXT_PROPOSAL: 'Submission.ContextProposal',
    CONTEXT_POLICY_CANCELLATION: 'Submission.ContextPolicyCancellation',
    CONTEXT_ENDORSEMENT: 'Submission.ContextEndorsement',
    CONTEXT_POLICY_REWRITE: 'Submission.ContextPolicyRewrite',
    CONTEXT_POLICY_REISSUE: 'Submission.ContextPolicyReissue',
    searchDelay: 750,
    CHAT_MEMBER_LIST_FALLBACK_POLLING_INTERVAL: 30000,
    DEFAULT_SUBMISSION_GRID_PAGE_SIZE: 25,
    LOCAL_STORAGE_SUBMISSION_GRID_PAGE_SIZE_KEY: 'submissionGridPageSize',
    DEFAULT_TASK_GRID_PAGE_SIZE: 25,
    LOCAL_STORAGE_TASK_GRID_PAGE_SIZE_KEY: 'taskGridPageSize'
});

